<template>
  <vs-popup
    :title="'Edit venue'"
    @close="handlePopupClose"
    :active.sync="showThisPopup"
    class="edit-venue-popup"
  >
    <vs-tabs v-if="clonedVenueDetails">
      <vs-tab label="Venue details">
        <h6>Venue name</h6>
        <p class="mb-1"><small>Name of venue</small></p>
        <vs-input
          class="inputx"
          placeholder="Venue name"
          v-model="clonedVenueDetails.name"
        />

        <h6 class="mt-6">Venue short-name</h6>
        <p class="mb-1"><small>Must be unique</small></p>
        <vs-input
          class="inputx"
          placeholder="Venue short name"
          v-model="clonedVenueDetails.shortName"
        />

        <h6 class="mt-6">Venue description</h6>
        <p class="mb-1">
          <small>Write a text to advertice the venue. 100-200 words.</small>
        </p>
        <vs-textarea
          placeholder="Describe the venue"
          v-model="clonedVenueDetails.description"
          height="150px"
        />

        <h6 class="mt-6">Venue address</h6>
        <p class="mb-1">
          <small>Address for the guest to find the venue</small>
        </p>
        <vs-input
          class="inputx"
          style="min-width: 22rem"
          placeholder="Placeholder"
          v-model="clonedVenueDetails.address"
        />

        <h6 class="mt-6">Venue logo</h6>
        <p class="mb-1"><small>Logo url</small></p>
        <vs-input
          class="inputx"
          style="width: 100%"
          placeholder="Placeholder"
          v-model="clonedVenueDetails.logo"
        />

        <h6 class="mt-6">Venue primary image</h6>
        <p class="mb-1"><small>Image url</small></p>
        <vs-input
          class="inputx"
          style="width: 100%"
          placeholder="Placeholder"
          v-model="clonedVenueDetails.image"
        />

        <h6 class="mt-6">Venue secondary images</h6>
        <p><small>Image urls</small></p>
        <div v-for="(image, index) in venueImages" :key="index" class="flex">
          <vs-input
            class="inputx mt-1"
            style="width: 100%"
            placeholder="Image url"
            v-model="image.url"
          />
          <vs-button
            class="mt-1 ml-2"
            @click="removeImage(index)"
            icon="remove"
          ></vs-button>
        </div>
        <vs-button size="small" class="mt-2" @click="addImage"
          >Add image</vs-button
        >

        <h6 class="mt-6">Venue tags</h6>
        <p>
          <small>Tags for the user to find. Use from predefined list.</small>
        </p>
        <div v-for="(tag, index) in tags" :key="'tag-' + index" class="flex">
          <vs-input
            class="inputx mt-1"
            style="width: 100%"
            placeholder="Tag name"
            v-model="tag.tagValue"
          />
          <vs-button
            class="mt-1 ml-2"
            @click="removeTag(index)"
            icon="remove"
          ></vs-button>
        </div>
        <vs-button size="small" class="mt-2" @click="addTag">Add tag</vs-button>

        <h6 class="mt-6">Venue obs info</h6>
        <p><small>Obs info. Use from predefined list.</small></p>
        <div
          v-for="(obsInfoItem, index) in obsInfo"
          :key="'obsInfoItem-' + index"
          class="flex"
        >
          <vs-input
            class="inputx mt-1"
            style="width: 100%"
            placeholder="Obs info name"
            v-model="obsInfoItem.key"
          />
          <vs-input
            class="inputx mt-1"
            style="width: 100%"
            placeholder="Obs info value"
            v-model="obsInfoItem.value"
          />
          <vs-button
            class="mt-1 ml-2"
            @click="removeObsInfoItem(index)"
            icon="remove"
          ></vs-button>
        </div>
        <vs-button size="small" class="mt-2" @click="addObsInfoItem"
          >Add obs info</vs-button
        >
      </vs-tab>

      <vs-tab label="Policies">
        <h6 class="mt-6 mb-4">Setup policies</h6>
        <edit-policies
          v-if="clonedVenueDetails"
          :object-with-policies="clonedVenueDetails"
          :policy-level="POLICY_LEVEL.Venue"
        ></edit-policies>
      </vs-tab>
      <vs-tab label="Compliance">
        
        <edit-booking-compliance
          v-if="clonedVenueDetails"
          :venueDetails="clonedVenueDetails"
        ></edit-booking-compliance>
      </vs-tab>
      <vs-tab label="Embed">
        <edit-venue-embed-booking
          v-if="clonedVenueDetails"
          :venueDetails="clonedVenueDetails"
        ></edit-venue-embed-booking>
      </vs-tab>
    </vs-tabs>

    <vs-row vs-w="12" vs-justify="flex-end">
      <vs-button
        color="primary"
        @click="handleSaveVenueClick"
        :disabled="!validForm"
        >Save Venue</vs-button
      >
    </vs-row>
  </vs-popup>
</template>

<script>
import * as _ from "lodash";
import { ACTIONS as VENUE_ACTIONS } from "@/store/modules/marcom/marcom";
import EditPolicies from "../components/policies/EditPolicies.vue";
import EditBookingCompliance from "../components/compliance/EditBookingCompliance.vue";
import EditVenueEmbedBooking from "../components/bookings/EditVenueEmbedBooking.vue";
import { POLICY_LEVEL } from "@/store/modules/marcom/data-model/policy-configurations/index.js";

export default {
  props: {
    venueDetails: {
      type: Object,
    },
  },
  components: {
    EditVenueEmbedBooking,
    EditPolicies,
    EditBookingCompliance,
  },
  data() {
    return {
      POLICY_LEVEL,
      clonedVenueDetails: undefined,
      venueImages: [],
      tags: [],
      obsInfo: [],
      showThisPopup: false,
    };
  },
  computed: {
    validForm() {
      return (
        !!this.clonedVenueDetails &&
        !!this.clonedVenueDetails.name &&
        !!this.clonedVenueDetails.name.trim() &&
        !!this.clonedVenueDetails.logo &&
        !!this.clonedVenueDetails.logo.trim() &&
        !!this.clonedVenueDetails.image &&
        !!this.clonedVenueDetails.image.trim() &&
        this.obsInfoHasNoEmptyKeys() &&
        this.obsInfoHasNoDupliateKeys() &&
        this.policiesValid
      );
    },
    policiesValid() {
      return (
        !!this.clonedVenueDetails &&
        this.clonedVenueDetails.venuePolicies.every((p) => p.isValid())
      );
    },
  },
  methods: {
    show() {
      if (!this.clonedVenueDetails) {
        this.clonedVenueDetails = _.cloneDeep(this.venueDetails);
      }

      this.venueImages = this.clonedVenueDetails.images.map((i) => {
        return { url: i };
      });

      this.tags = this.clonedVenueDetails.tags.map((i) => {
        return { tagValue: i.trim() };
      });

      if (this.clonedVenueDetails.obsInfo == null)
        this.clonedVenueDetails.obsInfo = {};
      _.toPairs(this.clonedVenueDetails.obsInfo).forEach(([key, value]) => {
        if (key.trim() !== "") this.obsInfo.push({ key: key, value: value });
      });

      this.showThisPopup = true;
    },
    addImage() {
      this.venueImages.push({ url: "" });
    },
    removeImage(index) {
      setTimeout(() => {
        this.clonedVenueDetails.images.splice(index, 1);
      }, 10);
    },
    addTag() {
      this.tags.push({ tagValue: "" });
    },
    removeTag(index) {
      setTimeout(() => {
        this.tags.splice(index, 1);
      }, 10);
    },
    addObsInfoItem() {
      this.obsInfo.push({ key: "", value: "" });
    },
    removeObsInfoItem(index) {
      setTimeout(() => {
        this.obsInfo.splice(index, 1);
      }, 10);
    },
    obsInfoHasNoEmptyKeys() {
      return !this.obsInfo.map((o) => o.key.trim()).includes("");
    },
    obsInfoHasNoDupliateKeys() {
      let set = new Set(this.obsInfo.map((o) => o.key.trim()));
      return set.size === this.obsInfo.length;
    },
    async handleSaveVenueClick() {
      this.$vs.loading();

      this.clonedVenueDetails.images = this.venueImages
        .filter((i) => i.url.trim() !== "")
        .map((i) => i.url);

      this.clonedVenueDetails.tags = this.tags
        .filter((t) => t.tagValue.trim() !== "")
        .map((t) => t.tagValue);

      this.clonedVenueDetails.obsInfo = {};
      let cv = this.clonedVenueDetails;
      this.obsInfo.forEach((element) => {
        if (element.key.trim() !== "") cv.obsInfo[element.key] = element.value;
      });

      //Call service
      try {
        var result = await this.$store.dispatch(
          "marcom/" + VENUE_ACTIONS.UpdateVenue,
          this.clonedVenueDetails
        );
        this.$vs.notify({
          color: "success",
          title: "Venue updated",
          text: "Your venue was updated",
        });

        this.handlePopupClose();
      } catch (err) {
        console.error(err);

        this.$vs.notify({
          color: "danger",
          title: "Venue updated",
          text: "Oops, something went wrong",
        });
      } finally {
        this.$vs.loading.close();
      }
    },
    handlePopupClose() {
      this.clonedVenueDetails = undefined;
      this.showThisPopup = false;
    },
  },
  mounted() {
    console.log("Mounted", this.venueDetails);
  },
};
</script>

<style lang="scss" scoped>
.edit-venue-popup::v-deep .vs-popup {
  width: 1080px;

  .vs-textarea {
    height: 145px !important;
  }

  .vs-popup--content {
    overflow: hidden;

    .vs-tabs--content {
      max-height: calc(100vh - 225px);
      overflow: auto;
      margin-top: 10px;
      margin-bottom: 10px;
    }
  }
}
</style>
